export default __webpack_public_path__ + "static/media/book-2.fb23d7c8.svg";